/**
 * Reads the GA4 client_id from the _ga cookie ("GA1.1.<clientId>.<timestamp>").
 * Returns the bare client_id (e.g. "1234567890.1700000000") for use with the
 * Measurement Protocol. Returns null when the cookie is missing or malformed.
 */
export function getGaClientId(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
  if (!match) return null;
  // Format: GA1.<version>.<clientId>.<timestamp> — clientId is the last two segments.
  const parts = match[1].split(".");
  if (parts.length < 4) return null;
  return `${parts[2]}.${parts[3]}`;
}
